import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import CloseIcon from '@mui/icons-material/Close';
import ParagraphControls from './ParagraphControls';
import InlineStyleControls from './InlineStyleControls';
import LinkControls from './LinkControls';
import ListControls from './ListControls';
import AlignControls from './AlignControls';
import Tooltip from '@mui/material/Tooltip';
import { useEditorContext } from '../../logic/EditorContext';
var VerticalDivider = function () { return React.createElement("div", { style: { height: '26px', width: '1px', margin: '0 10px 4px 10px', display: 'inline-block', backgroundColor: 'rgba(0, 0, 0, 0.26)' } }); };
var Controls = function (_a) {
    var _b = _a.customControls, customControls = _b === void 0 ? [] : _b;
    var componentHelper = useEditorContext()[0];
    return (React.createElement("div", { className: "RichEditor-ControlsRoot" },
        React.createElement("div", { className: "RichEditor-Control" },
            React.createElement("div", { className: "RichEditor-Control" },
                React.createElement(ParagraphControls, null)),
            React.createElement(VerticalDivider, null),
            React.createElement("div", { className: "RichEditor-Control" },
                React.createElement(InlineStyleControls, null)),
            React.createElement(VerticalDivider, null),
            React.createElement("div", { className: "RichEditor-Control" },
                React.createElement(ListControls, null)),
            React.createElement(VerticalDivider, null),
            React.createElement("div", { className: "RichEditor-Control" },
                React.createElement(AlignControls, null)),
            React.createElement(VerticalDivider, null),
            React.createElement("div", { className: "RichEditor-Control" },
                React.createElement(LinkControls, null)),
            React.createElement("div", { className: "RichEditor-Control RichEditor-Control--customControls" }, customControls.map(function (control, index) { return (React.createElement(React.Fragment, { key: "custom-control-" + index }, control)); }))),
        React.createElement(Tooltip, { title: "Exit Edit Mode" },
            React.createElement(SvgIcon, { component: CloseIcon, className: "RichEditor-CloseEditor RichEditor-singleControl", onMouseDown: componentHelper.activateReadOnlyMode, fontSize: "small" }))));
};
export default Controls;
//# sourceMappingURL=Controls.js.map